import { phpRequest } from "./phpRequest";

export const assignDevicesAPI = (deviceIds, companyGroupIds, subCompanyIds) => {
  return phpRequest.post("/devices/assign", {
    device_ids: deviceIds,
    company_group_ids: companyGroupIds,
    sub_company_ids: subCompanyIds,
  });
};
